/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Side_LeftInputs */

const en_us2_workout_logging_side_left = /** @type {(inputs: Workout_Logging_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left`)
};

const pt_br2_workout_logging_side_left = /** @type {(inputs: Workout_Logging_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquerda`)
};

const es_419_workout_logging_side_left = /** @type {(inputs: Workout_Logging_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izquierdo`)
};

const pt_pt2_workout_logging_side_left = /** @type {(inputs: Workout_Logging_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquerdo`)
};

const fr_fr2_workout_logging_side_left = /** @type {(inputs: Workout_Logging_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gauche`)
};

const de_de2_workout_logging_side_left = /** @type {(inputs: Workout_Logging_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links`)
};

const it_it2_workout_logging_side_left = /** @type {(inputs: Workout_Logging_Side_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinistro`)
};

/**
* | output |
* | --- |
* | "Left" |
*
* @param {Workout_Logging_Side_LeftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_side_left = /** @type {((inputs?: Workout_Logging_Side_LeftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Side_LeftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_side_left(inputs)
	if (locale === "es-419") return es_419_workout_logging_side_left(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_side_left(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_side_left(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_side_left(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_side_left(inputs)
	return en_us2_workout_logging_side_left(inputs)
});
export { workout_logging_side_left as "workout-logging.side_left" }